export default "__VITE_ASSET__CbLM7UmT__"